import { render } from "./GroundwaterAndSoilGrainSize.vue?vue&type=template&id=4d046736&scoped=true"
import script from "./GroundwaterAndSoilGrainSize.vue?vue&type=script&lang=ts"
export * from "./GroundwaterAndSoilGrainSize.vue?vue&type=script&lang=ts"

import "./GroundwaterAndSoilGrainSize.vue?vue&type=style&index=0&id=4d046736&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-4d046736"

export default script